import React, { useId } from 'react';
import { Spinner } from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';
import { IconType } from 'components/DesignSystem/Icon/icons';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import { StudyActionState } from 'helper/flux/myStudyRow';

export interface ActionButtonProps {
  /** Id legado do botão (ex.: `delete-study-<id>`), mantido para testes e E2E. */
  id: string;
  /** Nome acessível: Reenviar, Baixar, Cancelar ou Excluir. */
  label: string;
  icon: IconType;
  state: StudyActionState;
  /** Ação em andamento: spinner no lugar do ícone e clique ignorado. */
  busy?: boolean;
  /** Dica enquanto `busy` (ex.: "Preparando o arquivo…"). */
  busyHint: string;
  onClick: () => void;
}

/**
 * Uma das 4 posições fixas da coluna de ações. Desabilitada, continua na tela e na ordem de Tab
 * (`aria-disabled`): a dica aparece no hover e no foco, fecha com Esc, e o leitor de tela a lê
 * pelo `aria-describedby`.
 */
export default function ActionButton({
  id, label, icon, state, busy = false, busyHint, onClick,
}: ActionButtonProps) {
  const hint = busy ? busyHint : state.hint;
  // useId: o id da dica não colide nem se o mesmo estudo aparecer duas vezes na tela
  const hintId = useId();

  return (
    <TooltipWrapper title={hint} dismissOnEscape>
      <Button
        id={id}
        aria-label={label}
        aria-describedby={hintId}
        aria-disabled={!state.enabled || busy || undefined}
        icon={busy ? undefined : icon}
        className={`my-studies-action${busy ? ' icon-only' : ''}`}
        onClick={onClick}
      >
        {busy && <Spinner size="sm" />}
      </Button>
      <span id={hintId} className="visually-hidden">{hint}</span>
    </TooltipWrapper>
  );
}
